(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avelio-product-0"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('avelio-demo-counter')) {
  customElements.define('avelio-demo-counter', class extends HTMLElement {
    connectedCallback() {
      this.countNode = this.querySelector('[data-demo-count]');
      this.toggle = this.querySelector('[data-demo-toggle]');
      this.value = Math.min(40, Math.max(26, Number.parseInt(this.countNode.textContent, 10) || 26));
      this.countNode.textContent = this.value;
      this.paused = false;
      this.onToggle = () => {
        this.paused = !this.paused;
        this.toggle.textContent = this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        clearTimeout(this.timer);
        if (!this.paused) this.schedule();
      };
      this.toggle.addEventListener('click', this.onToggle);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (!this.isConnected || this.paused) return;
        if (!document.hidden) {
          const choices = [];
          for (let step = -4; step <= 4; step++) {
            const next = this.value + step;
            if (step !== 0 && next >= 26 && next <= 40) choices.push(next);
          }
          this.value = choices[Math.floor(Math.random() * choices.length)];
          this.countNode.textContent = this.value;
        }
        this.schedule();
      }, 6000 + Math.floor(Math.random() * 7001));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.toggle.removeEventListener('click', this.onToggle);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avelio-product-5"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('avelio-case-studies')) {
  customElements.define('avelio-case-studies', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.avelio-stories__track');
      const cards = Array.from(this.querySelectorAll('.avelio-stories__card'));
      const dots = Array.from(this.querySelectorAll('[data-review]'));
      const previous = this.querySelector('[data-previous]');
      const next = this.querySelector('[data-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const position = (card) => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - 24;
      let current = 0;
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth;
        const offsets = cards.map(card => Math.abs(Math.min(position(card), max) - track.scrollLeft));
        current = offsets.indexOf(Math.min(...offsets));
        if (track.scrollLeft >= max - 2) current = cards.length - 1;
        dots.forEach((dot, i) => {
          if (i === current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      const go = (index) => {
        const target = Math.max(0, Math.min(index, cards.length - 1));
        track.scrollTo({left:position(cards[target]),behavior:reducedMotion.matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => {
        const eligible = cards.map((card,i) => ({i,x:position(card)})).filter(item => item.x < track.scrollLeft - 3);
        go(eligible.length ? eligible[eligible.length - 1].i : 0);
      });
      next.addEventListener('click', () => go(current + 1));
      dots.forEach((dot,i) => dot.addEventListener('click', () => go(i)));
      track.addEventListener('scroll', sync, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') {event.preventDefault();next.click();}
        if (event.key === 'ArrowLeft') {event.preventDefault();previous.click();}
      });
      this.observer = new ResizeObserver(sync);
      this.observer.observe(track);
      sync();
    }
    disconnectedCallback() {if(this.observer) this.observer.disconnect();this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
